import createIcon from '../../createIcon';

/**
 * @component @name Update
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAuOTk5OCAxMC4xMkgxNC4yMTk4TDE2Ljk1OTggNy4zQzE0LjIyOTggNC42IDkuODA5NzYgNC41IDcuMDc5NzYgNy4yQzQuMzQ5NzYgOS45MSA0LjM0OTc2IDE0LjI4IDcuMDc5NzYgMTYuOTlDOS44MDk3NiAxOS43IDE0LjIyOTggMTkuNyAxNi45NTk4IDE2Ljk5QzE4LjMxOTggMTUuNjUgMTguOTk5OCAxNC4wOCAxOC45OTk4IDEyLjFIMjAuOTk5OEMyMC45OTk4IDE0LjA4IDIwLjExOTggMTYuNjUgMTguMzU5OCAxOC4zOUMxNC44NDk4IDIxLjg3IDkuMTQ5NzYgMjEuODcgNS42Mzk3NiAxOC4zOUMyLjEzOTc2IDE0LjkyIDIuMTA5NzYgOS4yOCA1LjYxOTc2IDUuODFDOS4xMjk3NiAyLjM0IDE0Ljc1OTggMi4zNCAxOC4yNjk4IDUuODFMMjAuOTk5OCAzVjEwLjEyWk0xMi40OTk4IDhWMTIuMjVMMTUuOTk5OCAxNC4zM0wxNS4yNzk4IDE1LjU0TDEwLjk5OTggMTNWOEgxMi40OTk4WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Update = createIcon('Update', [
  [
    'path',
    {
      d: 'M20.9998 10.12H14.2198L16.9598 7.3C14.2298 4.6 9.80976 4.5 7.07976 7.2C4.34976 9.91 4.34976 14.28 7.07976 16.99C9.80976 19.7 14.2298 19.7 16.9598 16.99C18.3198 15.65 18.9998 14.08 18.9998 12.1H20.9998C20.9998 14.08 20.1198 16.65 18.3598 18.39C14.8498 21.87 9.14976 21.87 5.63976 18.39C2.13976 14.92 2.10976 9.28 5.61976 5.81C9.12976 2.34 14.7598 2.34 18.2698 5.81L20.9998 3V10.12ZM12.4998 8V12.25L15.9998 14.33L15.2798 15.54L10.9998 13V8H12.4998Z',
      key: 'hmzeqb',
    },
  ],
]);

export default Update;
